import React from 'react';
import { CheckIcon, CircleIcon, LoaderCircleIcon } from 'lucide-react';
import type { TimelineEntry } from '../../types/services';
export function RequestTimeline({
  entries
}: {
  entries: TimelineEntry[];
}) {
  return <ol className="relative space-y-3.5 pl-6" data-id="element-4379" data-mp="16idsndpzdime">
      <span aria-hidden="true" className="absolute bottom-2 left-[7px] top-2 w-px bg-line" data-id="element-4380" data-mp="16fhze2p2vi4a" />
      {entries.map(entry => <li key={entry.id} className="relative" data-id="element-4381" data-mp="dtq4nadukf55">
          <span aria-hidden="true" className={`absolute -left-6 top-0.5 flex h-4 w-4 items-center justify-center rounded-full border ${entry.state === 'done' ? 'border-ok-700 bg-ok-700 text-white' : entry.state === 'current' ? 'border-brand-700 bg-brand-50 text-brand-800' : 'border-line-strong bg-surface text-ink-subtle'}`} data-id="element-4382" data-mp="dqu9tuxaq6kx">
            {entry.state === 'done' ? <CheckIcon className="h-2.5 w-2.5" data-id="element-4383" data-mp="3tep03aeedpn1" /> : entry.state === 'current' ? <LoaderCircleIcon className="h-2.5 w-2.5 animate-spin" data-id="element-4384" data-mp="3tghzc4mol7l0" /> : <CircleIcon className="h-1.5 w-1.5" data-id="element-4385" data-mp="3ohoqipica4r6" />}
          </span>
          <p className={`text-[13px] ${entry.state === 'upcoming' ? 'text-ink-muted' : 'font-medium text-ink'}`} data-id="element-4386" data-mp="3jn12err8zcd4">
            {entry.label}
          </p>
          <p className="cz-num text-[12px] text-ink-subtle" data-id="element-4387" data-mp="39s0sbx5gfm7o">
            {entry.at ?? 'Not yet'} · {entry.actor}
          </p>
          {entry.note && <p className="mt-0.5 text-[12px] leading-5 text-ink-muted" data-id="element-4388" data-mp="30p7zvqkjd4g9">{entry.note}</p>}
        </li>)}
    </ol>;
}